import { useState } from 'react';
import useCustomers from '../../../../hooks/useCustomers';
import './Piggypoints.scss';
import AdminAuthCheck from '../../../../components/AdminAuthCheck/AdminAuthCheck';
import { Loader } from '@piggytechng/component-library';
import dayjs from 'dayjs';
import NoData from '../../../../components/NoData/NoData';
import successIcon from '../../../../assets/icons/succesIcon.svg';
import failureIcon from '../../../../assets/icons/failureIcon.svg';
import chevronTable from '../../../../assets/icons/chevronTable.svg';
import PiggypointDetails from '../../../../components/NewSideSheet/PiggyPointDetails/PiggypointDetails';
import { formatToNaira } from '../../../../helpers/utils';

const Piggypoints = ({ userId }: any) => {
  const [adminAuthCheck, setAdminAuthCheck] = useState<boolean>(false);
  const [deviceToUnlink, setDeviceToUnlink] = useState<string | null>(null);
  const [show, setShow] = useState(false);
  const [trDetails, setTrDetails] = useState({});

  const { unlinkUserDevice, isLoadingUserDevices, piggyPointsForUser } = useCustomers();

  const handleShowTransactionsDetails = (singleData: any) => {
    setTrDetails(singleData);
    setShow(true);
  };

  const action = () => {
    deviceToUnlink && unlinkUserDevice(userId, deviceToUnlink);
    setDeviceToUnlink(null);
  };

  return (
    <>
      {adminAuthCheck && <AdminAuthCheck action={action} onClose={() => setAdminAuthCheck(false)} />}
      {isLoadingUserDevices ? (
        <div className="page-loader">
          <Loader color="#0F60D6" />
        </div>
      ) : (
        <div className="wallets-details">
          <h1 className="heading">Piggypoint History</h1>

          <div className="customers-filter">
            <div className="input-field">
              <form onSubmit={(e) => e?.preventDefault()}>
                <input
                  type="text"
                  placeholder="Search by Transaction ID, date"
                  // value={searchQuery}
                  // onChange={(e) => setSearchQuery(e.target.value)}
                />
              </form>
            </div>

            <div className="query-filter">
              <div>
                <svg width="10" height="10" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M0.75 0.75H17.25M6.75 13.25H11.25M3.75 7H14.25"
                    stroke="#1E293B"
                    strokeWidth="1.5"
                    strokeLinecap="square"
                  />
                </svg>
              </div>
              <div>Search</div>
            </div>

            <div className="query-filter">
              <div></div>
              <div>Reset</div>
            </div>
          </div>
          {piggyPointsForUser.activities.results?.length ? (
            <div className="table-container piggypoints">
              <table className="table">
                <thead className="table_head">
                  <tr>
                    <th className="icon">{''}</th>
                    <th>id</th>
                    <th>Ref</th>
                    <th>Points</th>
                    <th>Balance</th>
                    <th className="memo">Description</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody className="table-body">
                  {piggyPointsForUser.activities.results.map((txn: any) => (
                    <tr key={txn.arp_id} className="table-row" onClick={() => handleShowTransactionsDetails(txn)}>
                      <td className="icon">
                        <img src={txn.arp_value.toString()[0] === '-' ? failureIcon : successIcon} />
                      </td>
                      <td>{txn.arp_id}</td>
                      <td>{txn.arp_ref}</td>
                      <td>{txn.arp_value}</td>
                      <td>{txn.arp_balance ? formatToNaira(txn.arp_balance as number) : '-----'}</td>
                      <td className="memo">{txn.arp_memo}</td>
                      <td className="date">
                        {dayjs(txn.arp_date * 1000).format('D MMM YYYY')} <img src={chevronTable} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <NoData message="No transactions at the moment." />
          )}
        </div>
      )}

      <PiggypointDetails
        show={show}
        id={''}
        data={trDetails}
        onClose={() => {
          setShow(false);
        }}
      />
    </>
  );
};

export default Piggypoints;
